import { t } from '@luna/i18n';

const KIB = 1024;
const MAX_FILE_SIZE_MIB = 7;
const MAX_FILE_SIZE = MAX_FILE_SIZE_MIB * KIB * KIB;

export const ATTACHMENT_MIME_TYPES = ['application/pdf', 'image/jpeg', 'image/png'];

export function validateFile(file: File): void {
    if (typeof file === 'undefined' || !(file instanceof File)) {
        throw new Error(t('transaction.attachmentErrors.INVALID_FILE_TYPE'));
    }

    if (!ATTACHMENT_MIME_TYPES.includes(file.type)) {
        throw new Error(t('transaction.attachmentErrors.INVALID_FILE_TYPE'));
    }

    if (MAX_FILE_SIZE < file.size) {
        throw new Error(t('transaction.attachmentErrors.MAX_FILE_SIZE'));
    }
}
